var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7077 32.7522L25.1688 30.5174L19.4833 33.9008L15.5167 33.8991L9.82793 30.5174L2.29225 32.7522L0 25.0489L2.29225 16.4993L0 9.27094L2.29225 0.312256L14.0674 7.31554H20.9326L32.7077 0.312256L35 9.27094L32.7077 16.4993L35 25.0489L32.7077 32.7522Z",
    fill: "#FF5C16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.29395 0.312256L14.0691 7.32047L13.6008 12.1301L2.29395 0.312256Z",
    fill: "#FF5C16"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82959 25.0522L15.0106 28.9811L9.82959 30.5175V25.0522Z",
    fill: "#FF5C16"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5966 18.5565L13.6009 12.1333L7.22692 16.5009L7.22363 16.4993V16.5025L7.24335 20.9983L9.82809 18.5565H9.82974H14.5966Z",
    fill: "#FF5C16"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7077 0.312256L20.9326 7.32047L21.3993 12.1301L32.7077 0.312256Z",
    fill: "#FF5C16"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1722 25.0522L19.9912 28.9811L25.1722 30.5175V25.0522Z",
    fill: "#FF5C16"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7766 16.5025H27.7783H27.7766V16.4993L27.775 16.5009L21.401 12.1333L20.4053 18.5565H25.1722L27.7586 20.9983L27.7766 16.5025Z",
    fill: "#FF5C16"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82793 30.5175L2.29225 32.7522L0 25.0522H9.82793V30.5175Z",
    fill: "#E34807"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5947 18.5549L16.0341 27.8406L14.0393 22.6777L7.23975 20.9984L9.82613 18.5549H14.593H14.5947Z",
    fill: "#E34807"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1721 30.5175L32.7078 32.7522L35.0001 25.0522H25.1721V30.5175Z",
    fill: "#E34807"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4053 18.5549L18.9658 27.8406L20.9607 22.6777L27.7602 20.9984L25.1722 18.5549H20.4053Z",
    fill: "#E34807"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.0488L2.29225 16.4993H7.22183L7.23991 20.9967L14.0394 22.676L16.0343 27.8389L15.0089 28.976L9.82793 25.0472H0V25.0488Z",
    fill: "#FF8D5D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0001 25.0488L32.7078 16.4993H27.7783L27.7602 20.9967L20.9607 22.676L18.9658 27.8389L19.9912 28.976L25.1722 25.0472H35.0001V25.0488Z",
    fill: "#FF8D5D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9325 7.31543H17.4999H14.0673L13.6006 12.1251L16.0342 27.834H18.9656L21.4008 12.1251L20.9325 7.31543Z",
    fill: "#FF8D5D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.29225 0.312256L0 9.27094L2.29225 16.4993H7.22183L13.5991 12.1301L2.29225 0.312256Z",
    fill: "#661800"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.17 20.4199H10.9369L9.72095 21.6062L14.0409 22.6727L13.17 20.4182V20.4199Z",
    fill: "#661800"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7077 0.312256L34.9999 9.27094L32.7077 16.4993H27.7781L21.4009 12.1301L32.7077 0.312256Z",
    fill: "#661800"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.833 20.4199H24.0694L25.2853 21.6079L20.9604 22.676L21.833 20.4182V20.4199Z",
    fill: "#661800"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4817 30.8362L19.9911 28.9794L18.9658 27.8423H16.0327L15.0073 28.9794L15.5167 30.8362",
    fill: "#661800"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4816 30.8359V33.9021H15.5166V30.8359H19.4816Z",
    fill: "#C0C4CD"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82959 30.5142L15.52 33.9008V30.8346L15.0106 28.9778L9.82959 30.5142Z",
    fill: "#E7EBF6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1721 30.5142L19.4817 33.9008V30.8346L19.9911 28.9778L25.1721 30.5142Z",
    fill: "#E7EBF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMetamask);
export default __webpack_public_path__ + "static/media/icon_metamask.65b8275a56d2570ba2a4d58bd36fa428.svg";
export { ForwardRef as ReactComponent };